import "./index.css";
import { Privacy } from "./pages/Privacy";
import { Terms } from "./pages/Terms";

function Home() {
  return (
    <div className="text-center min-h-screen flex flex-col justify-center">
      <div className="flex-1 flex flex-col justify-center">
        <h1
          className="text-gray-500/90"
          style={{ fontFamily: "'Unthrift First Personal'", fontSize: "5rem", lineHeight: 1.2 }}
        >
          Kris & Heejin
        </h1>
        <p
          className="text-gray-400 text-lg"
          style={{ fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif" }}
        >
          Love you to the moon & back
        </p>
        <p
          className="text-gray-400/70 text-sm mt-6"
          style={{ fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif" }}
        >
          Our personal app for organizing calendars, tasks, and everyday life together.
        </p>
      </div>
      <footer className="pb-4 text-xs text-gray-300">
        <a href="/privacy-policy" className="hover:text-gray-400">Privacy</a>
        <span className="mx-2">·</span>
        <a href="/terms-of-service" className="hover:text-gray-400">Terms</a>
      </footer>
    </div>
  );
}

export function App() {
  const path = window.location.pathname;

  if (path === "/privacy-policy") {
    return <Privacy />;
  }

  if (path === "/terms-of-service") {
    return <Terms />;
  }

  return <Home />;
}

export default App;
